// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: z0M1xOwu3n6
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingBankingDetailsPersonal.module.css"; // plasmic-import: z0M1xOwu3n6/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingBankingDetailsPersonal__VariantProps =
  new Array();

export const PlasmicOnboardingBankingDetailsPersonal__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingBankingDetailsPersonal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__nqiXp)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__o2Cu
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox___0Lw9Q)}>
            <div className={classNames(projectcss.all, sty.freeBox__gyQDt)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__ntHs)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___8SvD)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__en28Q)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__e3GR)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__odnP)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__qm9XB)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__dMwwf)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__mDine)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__ahJ4H)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__zWOxb
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___1DGgP
                )}
              >
                {"Personal Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__bpN7R
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__pE03H
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__xeza6
                )}
              >
                {"Add your bank to receive payouts"}
              </div>
              <div
                data-plasmic-name={"addBankButton"}
                data-plasmic-override={overrides.addBankButton}
                className={classNames(projectcss.all, sty.addBankButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__auG8W
                  )}
                >
                  {"Add Bank"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "vertStack",
    "addBankButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  vertStack: ["vertStack", "addBankButton"],
  addBankButton: ["addBankButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicOnboardingBankingDetailsPersonal__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingBankingDetailsPersonal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingBankingDetailsPersonal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingBankingDetailsPersonal";
  } else {
    func.displayName = `PlasmicOnboardingBankingDetailsPersonal.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingBankingDetailsPersonal = Object.assign(
  // Top-level PlasmicOnboardingBankingDetailsPersonal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    vertStack: makeNodeComponent("vertStack"),
    addBankButton: makeNodeComponent("addBankButton"),
    // Metadata about props expected for PlasmicOnboardingBankingDetailsPersonal
    internalVariantProps: PlasmicOnboardingBankingDetailsPersonal__VariantProps,
    internalArgProps: PlasmicOnboardingBankingDetailsPersonal__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingBankingDetailsPersonal;
/* prettier-ignore-end */
